import { useQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
import { LoggedUser } from './types/LoggedUser';

const loggedUserQuery = loader('./queries/GetLoggedUserQuery.gql');
export function useLoggedUser() {
  return useQuery<{ getLoggedUser: LoggedUser }>(loggedUserQuery);
}
